if( ! window._bilingualTheme.settings["fix_thumbnail_image_height"] ) {
	$(function() {
		var thumbnails = $('#collection .thumbnail, .thumbnail-small'),
			images = $('.product-thumbnail-image');

	window.resizeThumbnailImages = function(){
		var maxHeight = 0,
			minHeight = 0;

		$.each(images, function(i, obj) {
			obj = $(obj);
			var image = obj.find('img').first(),
				imgHeight = image.innerHeight();

			if(minHeight != 0){
				minHeight = (imgHeight < minHeight) ? imgHeight : minHeight;
			}else{
				minHeight = imgHeight;
			}

			maxHeight = (imgHeight > maxHeight) ? imgHeight : maxHeight;
		});

		var diff = maxHeight - minHeight;
		if( diff > 50 ){
			maxHeight = minHeight + (diff / 2);
		}

		images.height(maxHeight);
	}
	window.resizeThumbnails = function(){
		var maxHeight = 0;

		$.each(thumbnails, function(i, obj) {
			obj = $(obj);

			var contents = obj.find(">*"),
				totalHeight = 0;

			$.each(contents, function(i, val) {
				val = $(val);
				totalHeight += val.height();
			});

			maxHeight = (totalHeight > maxHeight) ? totalHeight : maxHeight;
		});

		thumbnails.height(maxHeight);
	}

		setTimeout(function(){
			window.resizeThumbnailImages();
			window.resizeThumbnails();
		}, 300);

		$(window).on('resize', function(e){
			window.resizeThumbnailImages();
			window.resizeThumbnails();
		});
	});
}